import { render } from "./PresenceRenderer.vue?vue&type=template&id=6fd856d8"
import script from "./PresenceRenderer.vue?vue&type=script&lang=js"
export * from "./PresenceRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__